import {toEither} from 'Core/models/Async';
import * as EnrollTrackUserActions from 'Enrollment/ducks/enrollTrackUser';
import {sequenceS} from 'fp-ts/lib/Apply';
import * as E from 'fp-ts/lib/Either';
import {constant, flow} from 'fp-ts/lib/function';
import * as O from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {RouteComponentProps, withRouter} from 'react-router';
import {ReducerState} from 'rootReducer';
import {renderAsync} from 'Shared/components/RenderAsync';
import EnrollTrackUserForm from 'Users/components/UserAdministration/EnrollTrackUserForm';

type EnrollTrackUserProps = ReturnType<typeof mapStateToProps> &
  typeof EnrollTrackUserActions &
  RouteComponentProps<{userId: string}>;

export const EnrollTrackUserEntry = (props: EnrollTrackUserProps) => {
  const enrollTrackUserId = O.fromNullable(props.match.params.userId);
  const originalEnrollTrackOption = pipe(
    props.originalEnrollTrackUser,
    O.fold(constant(O.none), flow(toEither, O.fromEither))
  );

  useEffect(() => {
    O.option.ap(O.some(props.getUser), enrollTrackUserId);
    props.getRoles();

    return () => {
      props.clearUser();
    };
  }, []);

  return pipe(
    sequenceS(E.either)({
      enrollTrackUserId: E.right(enrollTrackUserId),
      original: E.right(originalEnrollTrackOption),
      user: toEither(props.enrollTrackUser),
      roles: toEither(props.asyncRoles),
    }),
    E.fold(renderAsync, enrollTrackFormProps => <EnrollTrackUserForm {...props} {...enrollTrackFormProps} />)
  );
};

const mapStateToProps = (state: ReducerState) => ({
  enrollTrackUser: state.enrollTrackUser.user,
  originalEnrollTrackUser: state.enrollTrackUser.original,
  asyncRoles: state.enrollTrackUser.roles,
  userClaims: state.user.profile.userClaims,
});

export default withRouter(
  connect(mapStateToProps, {
    ...EnrollTrackUserActions,
  })(EnrollTrackUserEntry)
);
